import { Box, Button, FormControl, MenuItem, Modal, Select, Typography } from "@mui/material";
import { Loader, ShowToastError, ShowToastSuccess } from "@platformx/utilities";
import { useEffect, useState } from "react";
import graphQluserRole from "../../api/fetch";

export default function DeleteRole({
  openModal,
  setOpenModal,
  selectedColumn,
  setSelectedColumn,
  columns,
  setTriggerUpdate,
}) {
  const [dropdownValue, setDropdownValue] = useState(columns?.[0]?.id);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  const handleDelete = () => {
    deleteUserRole();
  };
  const deleteUserRole = async () => {
    try {
      setLoading(true);
      const res = await graphQluserRole.deleteRole({
        input: {
          delete_role_id: selectedColumn?.id,
          selected_role_id: dropdownValue,
        },
      });
      if (res?.data?.authoring_deleteRole?.message) {
        ShowToastSuccess(res?.data?.authoring_deleteRole?.message);
        setTriggerUpdate((prev) => !prev);
      } else {
        ShowToastError("Failed to delete role");
      }
    } catch (error) {
      ShowToastError("Failed to delete role");
    } finally {
      setLoading(false);
      setOpenModal(false);
      setSelectedColumn(null);
    }
  };
  const fetchImpactedUsersCount = async () => {
    try {
      setLoading(true);
      const response = await graphQluserRole.getImpactedUserList({
        role_id: selectedColumn?.id,
      });
      if (response?.data?.authoring_roleUserList?.user_count) {
        setCount(response.data.authoring_roleUserList.user_count);
      }
    } catch (error) {
      ShowToastError("Failed to fetch impacted users count");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchImpactedUsersCount();
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: 24,
              background: "white",
              borderRadius: 4,
              padding: 4,
              width: "650px",
            }}>
            <Typography component='h2' variant='h3semibold'>
              Confirm Delete Role
            </Typography>
            <Typography variant='p3regular' sx={{ marginBottom: 1, marginTop: 2 }}>
              Are you sure you want to delete <strong>{selectedColumn?.role}</strong> role?
              <strong>
                {count > 0 &&
                  ` Please
              note that deleting this role will affect ${count} Users. `}
              </strong>
              {count > 0 &&
                `If you proceed, you must assign a new role to ensure the impacted users are properly reassigned.`}
            </Typography>

            {count > 0 && (
              <FormControl fullWidth>
                <Typography variant='p3semibold' sx={{ marginBottom: 1 }}>
                  Select a Role to Reassign
                </Typography>
                <Select
                  value={dropdownValue}
                  onChange={(e) => setDropdownValue(e.target.value)}
                  label='Dropdown 2'>
                  {columns?.map((item) => (
                    <MenuItem value={item.id} key={item.id}>
                      {item?.role}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {/* Delete and Cancel Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                marginTop: 4,
              }}>
              <Button color='secondary' onClick={handleDelete} variant='primaryButton'>
                {count > 0 ? "Delete & Assign" : "Delete"}
              </Button>
              <Button onClick={() => setOpenModal(false)} variant='secondaryButton'>
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
}
